// AKM POC §5.15 — Devam Paneli → rapor listeleri sorgu dizesi sözleşmesi.
//
// Panel göstergeye / grafiğe / "Tümü →" bağlantısına tıklanınca ilgili PDKS rapor listesini AYNI süzgeçlerle açar:
//   ?from=yyyy-MM-dd&to=yyyy-MM-dd&employeeStatusId=…&userGroupId=…&departmentId=…&locationId=…
// Rapor sayfaları bunu okur (readAttendancePreset) ve her tablo isteğine YAPIŞKAN olarak ekler (applyAttendancePreset):
// DataTable süzgeç listesini tohumlayamadığı ve onTableChanged parametreleri sıfırdan kurduğu için preset her
// değişimde yeniden eklenmezse 2. sayfada sessizce düşer. Kullanıcının tabloda seçtiği tarih panelin tarihini EZER.

export const ATTENDANCE_QUERY_KEYS = ['from', 'to', 'employeeStatusId', 'userGroupId', 'departmentId', 'locationId'];

const GUID_KEYS = ['employeeStatusId', 'userGroupId', 'departmentId', 'locationId'];
const DATE_FILTER_KEYS = ['date[between]', 'date[gte]', 'date[lte]'];
const GUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
const ISO_DAY_RE = /^(\d{4})-(\d{2})-(\d{2})$/;

const filled = (v) => v !== null && v !== undefined && v !== '';

export function isIsoDay(value) {
  if (typeof value !== 'string') return false;
  const m = ISO_DAY_RE.exec(value);
  if (!m) return false;
  const [y, mo, d] = [Number(m[1]), Number(m[2]), Number(m[3])];
  const date = new Date(Date.UTC(y, mo - 1, d));
  return date.getUTCFullYear() === y && date.getUTCMonth() === mo - 1 && date.getUTCDate() === d;
}

/** '?from=…&to=…&…' — yalnız dolu anahtarlar, ATTENDANCE_QUERY_KEYS sırasıyla; hiçbiri yoksa ''. */
export function buildAttendanceSearch(query) {
  if (!query) return '';
  const parts = ATTENDANCE_QUERY_KEYS
    .filter((key) => filled(query[key]))
    .map((key) => `${key}=${encodeURIComponent(query[key])}`);
  return parts.length ? `?${parts.join('&')}` : '';
}

/**
 * location.search → preset. Sözleşme anahtarlarından hiçbiri yoksa null. Geçersiz değerler düşer: tarih çifti
 * ikisi de geçerli gün ve from ≤ to değilse ikisi de null; GUID olmayan kimlik null.
 */
export function readAttendancePreset(search) {
  const params = new URLSearchParams(search || '');
  if (!ATTENDANCE_QUERY_KEYS.some((key) => params.has(key))) return null;

  let from = params.get('from');
  let to = params.get('to');
  if (!isIsoDay(from) || !isIsoDay(to) || from > to) {
    from = null;
    to = null;
  }
  const preset = { from, to };
  GUID_KEYS.forEach((key) => {
    const value = params.get(key);
    preset[key] = value && GUID_RE.test(value) ? value : null;
  });
  return preset;
}

export function hasAttendancePreset(preset) {
  if (!preset) return false;
  return Boolean((preset.from && preset.to) || GUID_KEYS.some((key) => filled(preset[key])));
}

/**
 * Tablo isteğine preset'i ekler. Tarih: params'ta kullanıcının tarih süzgeci (date[between|gte|lte]) YOKSA
 * 'date[between]' = 'from,to'. Kimlikler: departmentId / locationId / userGroupId / employeeStatusId.
 */
export function applyAttendancePreset(params, preset) {
  if (!preset) return params;
  const out = { ...params };
  const userPickedDate = DATE_FILTER_KEYS.some((key) => filled(out[key]));
  if (!userPickedDate && preset.from && preset.to) out['date[between]'] = `${preset.from},${preset.to}`;
  // AKM POC §7.5 — rapor sayfalarında aynı süzgeçler tablonun kendi süzgeç sütunlarıdır: kullanıcının tabloda seçtiği
  // değer panelin değerini EZER (tarihle aynı kural).
  GUID_KEYS.forEach((key) => {
    if (filled(preset[key]) && !filled(out[key])) out[key] = preset[key];
  });
  return out;
}

/** Yalnız panelin koyduklarını siler: preset'e EŞİT kimlik anahtarları ve date[between] (tablodaki seçim kalır). */
export function stripAttendancePreset(params, preset) {
  if (!preset) return params;
  const out = { ...params };
  GUID_KEYS.forEach((key) => { if (filled(preset[key]) && out[key] === preset[key]) delete out[key]; });
  if (preset.from && preset.to && out['date[between]'] === `${preset.from},${preset.to}`) delete out['date[between]'];
  return out;
}

export const DRILL_PATHS = {
  late: '/pdks-reports/tardiness',
  early: '/pdks-reports/early-departure',
  absent: '/pdks-reports/absenteeism',
  undertime: '/pdks-reports/undertime',
};

/** Panelden rapora bağlantı: { pathname, search } — overrides panelin sorgusunu ezer (tek gün, departman…). */
export function buildDrillLink(kind, query, overrides = {}) {
  return { pathname: DRILL_PATHS[kind], search: buildAttendanceSearch({ ...(query || {}), ...overrides }) };
}
